import React from "react";

const EmptyBank = () => {
  return (
    <div>
      <svg
        width={120}
        height={120}
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          opacity={0.1}
          cx={60}
          cy={116.397}
          rx={60}
          ry={3.6}
          fill="#044E97"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8 23.56a3.161 3.161 0 116.324 0v6.504a3.161 3.161 0 11-6.323 0V23.56zm3.162-.762a.762.762 0 00-.761.762v6.504a.761.761 0 101.523 0V23.56c0-.42-.341-.762-.762-.762zm11.239 13.2a6 6 0 016-6h39.93a16.744 16.744 0 00-3.544 7.2H31.201v-1.2zm42.042 3.6H26.401a6 6 0 00-6 6v6h56.73a16.732 16.732 0 01-3.93-10.8c0-.403.014-.803.042-1.2zm19.158 17.83v24.17h2.4a6 6 0 006-6v-21.93a16.73 16.73 0 01-8.4 3.76zm10.8-6.236v24.406a8.4 8.4 0 01-8.4 8.4h-2.4v1.2a8.4 8.4 0 01-8.4 8.4H26.4a8.4 8.4 0 01-8.4-8.4v-39.6a8.4 8.4 0 018.4-8.4h2.4v-1.2a8.4 8.4 0 018.4-8.4h42v.331A16.732 16.732 0 0190 24c9.278 0 16.8 7.521 16.8 16.8 0 3.923-1.346 7.533-3.6 10.393zm-82.8 7.606H90v26.4a6 6 0 01-6 6H26.4a6 6 0 01-6-6v-26.4zm79.961 28.8a3.161 3.161 0 00-3.161 3.162v6.504a3.161 3.161 0 106.323 0V90.76a3.162 3.162 0 00-3.162-3.162zm-.761 3.162a.761.761 0 111.523 0v6.504a.762.762 0 01-1.523 0V90.76zm-24-49.962c0-7.953 6.447-14.4 14.4-14.4s14.4 6.448 14.4 14.4c0 7.953-6.447 14.4-14.4 14.4s-14.4-6.447-14.4-14.4zm11.4-7.8a3 3 0 016 0v7.2a3 3 0 01-6 0v-7.2zm3-.6a.6.6 0 00-.6.6v7.2a.6.6 0 101.2 0v-7.2a.6.6 0 00-.6-.6zm0 19.2a3 3 0 110-6 3 3 0 010 6zm-.6-3a.6.6 0 101.2 0 .6.6 0 00-1.2 0zm-40.8 21a3 3 0 000 6H81a3 3 0 000-6H48.6zm-.6 3a.6.6 0 01.6-.6H81a.6.6 0 010 1.2H48.6a.6.6 0 01-.6-.6zm-15 5.4a5.4 5.4 0 100-10.8 5.4 5.4 0 000 10.8z"
          fill="#044E97"
        />
      </svg>
    </div>
  );
};

export default EmptyBank;
